import {PaginatedServiceArgs} from 'src/types';
import {RatesControlData} from 'src/app/administration/ratesControl/store/types';
import {guardedFetcher} from 'src/utils/guardedFetcher';

const prefix = 'crud/rates';

export const RatesControlServices = {
    get: ({params}: PaginatedServiceArgs) => guardedFetcher.get<PaginateResponse<RatesControlData>>(`${prefix}`, {params}),
};
